<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header="<i class='fa fa-star'></i> Berita Dashboard">
            <button type="button" @click="showModal" class="btn btn-outline-primary">Tambah Berita</button>
            <br></br>
            <div v-if="isLoading" > 
            <center>
              <v-pulse></v-pulse>
            </center>
            </div>
            <div v-else class="table-responsive">

            <table class="table table-striped table-bordered table-hover" >
                <thead>
                  <tr>
                      <th>No</th> 
                      <th>Judul</th>
                      <th>Nama Funding</th>
                      <th>Tanggal</th>
                      <th>Konten</th>
                      <th>Gambar</th>
                  </tr>
                </thead>
                
                <tbody v-if="newsList.length > 0">
                    <tr v-for="(value,index) in newsList" :key="index">
                        <td>{{index+1}}</td>
                        <td>{{value.title}}</td>
                        <td>{{value.nama_fundings}}</td>
                        <td>{{value.date}}</td>
                        <td>{{getParagraf(value.content)}}</td>
                        <td>
                            <b-img class="imageFile" thumbnail fluid :src="'https://res.cloudinary.com/wahyupermadie/image/fetch/c_fill,g_auto:face,h_120,w_120,fl_force_strip.progressive/f_webp/https://hackathon.futnet.id/news/'+value.foto" alt="Thumbnail" />
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <td colspan="6">
                        <center>
                            Tidak Ada Data
                        </center>
                    </td>
                </tbody>
              </table>
            </div>
          </b-card>
        </b-col><!--/.col-->
      </b-row><!--/.row-->

      <b-modal title="Tambah Berita" class="modal-primary" v-model="isModalVisible" @ok="addNews">
        <b-form enctype="multipart/form-data">
            <b-form-group
                label="Judul Berita"
                label-for="title">
                <b-form-input v-model="news.title" required id="title" type="text" placeholder="Judul Berita" autocomplete="title"></b-form-input>
            </b-form-group>
            <b-form-group
                label="Pilih Pendanaan"
                label-for="fundings">
                <v-select v-model="selected" :options="fundings"></v-select>
            </b-form-group>
            <b-form-group
                label="Tanggal Berita"
                label-for="date">
                <b-form-input v-model="news.date" required id="date" type="date" placeholder="Tanggal Berita" autocomplete="date"></b-form-input>
            </b-form-group>
            <b-form-group
                label="Konten Berita"
                label-for="konten">
                <textarea v-model="news.content" required class="form-control" placeholder="Konten Berita" rows="5" id="content"></textarea>
            </b-form-group>
            <b-form-group
                label="Foto Berita"
                label-for="foto">
                <b-form-file v-model="news.foto" id="newsfoto" name="newsfoto" placeholder="Foto Berita" @change="onFileChange"></b-form-file>
            </b-form-group>
           <b-form-group>
            <b-img 
              class="imageFile" 
              center 
              :src="urlFoto" 
              alt="center image">
            </b-img>
          </b-form-group>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {getCache,storedCache} from '@/cache'
import constant from '../../utils/constant.js'
import axios from 'axios'
const REGEX_FIRST_PARAGRAPH = /<p>.*.<\/p>\n</g

export default {
  data () {
    return {
        news : {},
        newsList : [],
        fundings :[],
        selected : null,
        isModalVisible: false,
        attachments: [],
        previewImage: [],
        isLoading: false,
        token : '',
        user_id : '',
        urlFoto : 'https://www.asuci.uci.edu/wp-content/uploads/2018/07/blank-profile-picture-973460-960-720.png'
    }
  },
  created(){
        this.user_id = localStorage.getItem('user_id')
        this.token = localStorage.getItem('user_token')
        this.getData()
        this.getFunding()
  },
  watch: {
    '$route' : 'getData'
  },
  beforeMount()
  {
    
  },
  methods:{
        getParagraf(text)
        {
            return text.substring(0, 200)
        },
        openSpinner()
        {
            this.isLoading = true
        },
        closeSpinner()
        {
            this.isLoading = false
        },
        showModal() {
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        addNews(e)
        {
            e.preventDefault()
            var foto = document.getElementById('filefunding')
            let formData = new FormData()
            formData.append('foto',this.news.foto)    
            if(this.selected != null){
                formData.append('funding_id', this.selected['value'])
                // alert('1')
            }else{
                formData.append('funding_id', '')
            }
            formData.append('title', this.news.title)
            formData.append('date', this.news.date)
            formData.append('content', this.news.content)
            this.openSpinner()
            axios.post(constant._BASE_URL+"news",formData,{
                headers:{
                    'Content-type': 'application/json',
                    'Authorization' : 'Bearer '+this.token,
                }
            }).then(response => {
                this.closeSpinner()
                this.getData()
                alert('sukses')
            }).catch(error => {
                alert(error)
                this.closeSpinner()
            })
            this.closeModal()
        },
        getFunding()
        {
                const token = localStorage.getItem(`user_token`);
                axios.get(constant._BASE_URL+"funding",{ 
                    headers: {
                    'Content-type': 'application/json',
                    'Authorization' : 'Bearer '+this.token,
                    }
                }).then(response => {
                        var funding = response.data
                        storedCache('funding'+this.user_id, funding)

                        var fundings = getCache('funding'+this.user_id)
                        for(let i=0;i<fundings.length;i++)
                        {
                            let data = {
                                'label' : fundings[i]['title'],
                                'value' : fundings[i]['id']
                            }
                            this.fundings.push(data)
                        }

                }).catch(error => {
                        alert(error)
                        var fundings = getCache('funding'+this.user_id)
                        for(let i=0;i<fundings.length;i++)
                        {
                            let data = {
                                'label' : fundings[i]['title'],
                                'value' : fundings[i]['id']
                            }
                            this.fundings.push(data)
                        }
                });
            
        },
        getData()
        {
            this.openSpinner()
            axios.get(constant._BASE_URL+"news",{
                headers:{
                    'Content-type': 'application/json',
                    'Authorization' : 'Bearer '+this.token,
                }
            }).then(response => {
                storedCache('news'+this.user_id,response.data)
                this.newsList = getCache('news'+this.user_id)
                console.log(response.data)
                this.closeSpinner()
            }).catch(error => {
                alert(error)
                this.newsList = getCache('news'+this.user_id)
                this.closeSpinner()
            })
        },
        onFileChange(e)
        {
            this.previewImage = []
            const file = e.target.files[0]
            this.urlFoto = URL.createObjectURL(file)
        },
  }
}
</script>
<style scoped>
.imageFile {
  height: 150px;
}
.imageHome {
  width: 30%;
  display: inline-block;
  margin-left: 0dp;
  margin-right: 0dp;
}
</style>



// WEBPACK FOOTER //
// src/components/news/News.vue